var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-button',{attrs:{"type":"primary","size":"mini"},on:{"click":_vm.saveLifeCycle}},[_vm._v(" 保存 ")]),_c('codemirror',{ref:"codemirror",model:{value:(_vm.code),callback:function ($$v) {_vm.code=$$v},expression:"code"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }